import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../environments/environment';
import {LoginService} from '../services/login.service';
import { Usuario } from '../models/usuario';
import { Response } from '../interface/response';
import { Perfil } from '../models/perfil';
import { UsuarioConectado } from '../models/usuarioConectado';

@Injectable({providedIn:'root'})
export class UsuarioService {
    public url: string;

    constructor(private _http: HttpClient, private _loginService : LoginService) {
        this.url = environment.url;
    }

    Todos() {
        return this._http.get<Response<Usuario>>(this.url + 'Usuario', { headers: new HttpHeaders().set('Content-Type', 'application/json').set("Authorization",this._loginService.getToken()) });
    }

    PorId(usuario:Usuario) {
        return this._http.get<Response<Usuario>>(this.url + 'Usuario/PorId/' + usuario.correo, { headers: new HttpHeaders().set('Content-Type', 'application/json').set("Authorization",this._loginService.getToken()) });
    }

    PorPerfil(perfil:Perfil) {
        return this._http.get<Response<Usuario>>(this.url + 'Usuario/PorPerfil/' + perfil.id, { headers: new HttpHeaders().set('Content-Type', 'application/json').set("Authorization",this._loginService.getToken()) });
    }
Registra(usuario:Usuario){
        return this._http.post<Response<Usuario>>(this.url + 'Usuario', usuario, { headers: new HttpHeaders().set('Content-Type', 'application/json').set("Authorization",this._loginService.getToken()) });
    }

    ModoOscuro(usuario:Usuario){
        return this._http.put<Response<Usuario>>(this.url + 'Usuario/ModoOscuro', usuario, { headers: new HttpHeaders().set('Content-Type', 'application/json').set("Authorization",this._loginService.getToken()) });
    }

    Actualiza(usuario:Usuario){
        return this._http.put<Response<Usuario>>(this.url + 'Usuario', usuario, { headers: new HttpHeaders().set('Content-Type', 'application/json').set("Authorization",this._loginService.getToken()) });
    }

    Elimina(usuario:Usuario){
        return this._http.delete<Response<Usuario>>(this.url + 'Usuario/' + usuario.correo, { headers: new HttpHeaders().set('Content-Type', 'application/json').set("Authorization",this._loginService.getToken()) });
    }
    Conectados() {
        return this._http.get<Response<UsuarioConectado>>(this.url + 'Usuario/Conectados', { headers: new HttpHeaders().set('Content-Type', 'application/json').set("Authorization",this._loginService.getToken()) });
    }
}


